import React, { useState, Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { v4 as uuidv4 } from 'uuid';
import { useStateIfMounted } from 'use-state-if-mounted'
import { useDispatch, useSelector } from 'react-redux'
import {
    actualizarFC_06PaginaActiva, ObtenerClientePorLogin06,
    obtenerContadorDeFechaFolio, agregarFC_06Accion,
    resetDataFC_06, actualizarFC_06Solicitud,
    actualizarFC_06Estatus, actualizarFC_06SolicitudBorrador,
    eliminarFC_06AnexoPredioBD, eliminarFC_06AnexoViveroBD

} from '../../../redux/DucksBeneficiario/FC_06Ducks';
import { withRouter } from 'react-router-dom'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import moment from 'moment'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import estilos from './FormularioFC06BeneficiarioComponent.module.css';
import InfoBar from '../../App/InfoBar'
import BotonAtrasSiguienteComponent from '../../App/BotonAtrasSiguienteComponent';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import TablaPredio from './TablaPredio';
import TablaVivero from './TablaVivero';
import { set } from 'date-fns';
import { Formik } from 'formik'
const { useEffect, useRef } = React;
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { obtenerSolicitudesWithStatus } from '../../../redux/SolicitudesDucks';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
import DocumentacionFC_06Component from './DocumentacionFC_06Component';
function FormularioFC06BeneficiarioComponent(props) {

    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)

    const idUsuario = usuario.data.user[0].id

    let fc_06 = useSelector(store => store.FC_06Solicitud.fc_06)
    let fc_06Map = useSelector(store => store.FC_06Solicitud.fc_06Map)
    let fc_06PrediosMap = useSelector(store => store.FC_06Solicitud.prediosMap)
    let fc_06ViverosMap = useSelector(store => store.FC_06Solicitud.viverosMap)
    let filesViverosMap = useSelector(store => store.FC_06Solicitud.filesViverosMap)
    let filesPrediosMap = useSelector(store => store.FC_06Solicitud.filesPrediosMap)
    const modoEdicionBorrador = useSelector(store => store.FC_06Solicitud.modoEdicionBorrador)
    let data = useSelector(store => store.FC_06Solicitud.data)
    const modoCorreccion = useSelector(store => store.FC_06Solicitud.modoCorreccion)
    let dataCliente = useSelector(store => store.FC_06Solicitud.cliente)
    let dataLogin = useSelector(store => store.FC_06Solicitud.dataLogin)
    let predios = useSelector(store => store.FC_06Solicitud.predios)
    let viveros = useSelector(store => store.FC_06Solicitud.viveros)
    var fechaHoy = moment().format('YYYY-MM-DD');
    const domicilio = useSelector(store => store.FC_06Solicitud.domiclio)
    const [idlogin, setidlogin] = useStateIfMounted(idUsuario)
    const store = useSelector(store => store)
    const noActualizarBorrador = useRef(true)
    const currentUser = useSelector(store => store.Usuario.data)
    React.useEffect(() => {
        if (!(JSON.stringify({}) === JSON.stringify(data))) {
            fc_06 = data
        }
        if (!(JSON.stringify({}) == JSON.stringify(fc_06))) {

            /*if (fc_06Predios.data) {
                if (fc_06Predios.data.data) {
                    setPredios(fc_06Predios.data.data)
                } else {
                    setPredios(fc_06Predios.data)
                }
            }*/
        }
    }, [fc_06, data])

    React.useEffect(() => {
        let data = dispatch(ObtenerClientePorLogin06({ idlogin: usuario.data.user[0].id }))
    }, [])

    React.useEffect(() => {
        if (predios?.[0]) {
            setPredio(predios?.[0])
        } else {
            setPredio([])
        }
    }, [predios])

    React.useEffect(() => {
        if (viveros?.[0]) {
            setVivero(viveros?.[0])
        } else {
            setVivero([])
        }
    }, [viveros])

    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
        setDataModal(data.data)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        setDataModal('')
    }
    let botonEnviarRegistro = false
    let botonEnviarBorrador = false
    const [botonEnviarCorrecciones, setBotonEnviarCorrecciones] = React.useState(false)
    const [functionResetForm, setFunctionResetForm] = React.useState()
    const [functionSubmitForm, setFunctionSubmitForm] = React.useState()
    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p className={`${estilos.bodyModal}`}>{bodyModal}</p> <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => {
                                switch (accion) {
                                    case 'enviarSolicitudFC_06':
                                        activarBotonEnviarForm()
                                        functionSubmitForm.function()
                                        break;
                                    case 'enviarCorreccion':
                                        activarBotonEnviarCorreciones()
                                        functionSubmitForm.function()
                                        break;
                                    case 'reiniciarFormato':
                                        handleResetAllPropertys()
                                        functionResetForm.function()
                                        break;
                                    case 'guardarBorrador':
                                        guardarBorrador(dataModal)
                                        break;
                                    case 'actualizarBorrador':
                                        actualizarBorrador(dataModal)
                                        break;
                                    case 'enviarSolicitudBorradorFC_06':
                                        activarBotonEnviarBorrador()
                                        functionSubmitForm.function()
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    const activarBotonEnviarForm = () => {
        botonEnviarRegistro = true
    }
    const activarBotonEnviarBorrador = () => {
        botonEnviarBorrador = true
    }
    const activarBotonEnviarCorreciones = () => {
        setBotonEnviarCorrecciones(true)
    }
    const botonEnviarSolicitudFC_06 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudFC_06'
        })
    }
    const botonEnviarCorreccionesFC_06 = async () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de enviar las correcciones al personal de atención al cliente, 
            ya no podrá seguir corrigiendo esta solicitud.`,
            accion: 'enviarCorreccion'
        })
    }
    const botonGuardarComoBorrador = async (valores) => {
        if (modoEdicionBorrador) {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de actualizar este borrador de solicitud.
                Los archivos de la sección final no se guardarán, puesto que es un borrador del formulario.`,
                accion: 'actualizarBorrador',
                data: valores
            })
        } else {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de guardar esta solicitud en su apartado de borradores.
                Los archivos de la sección final no se guardarán puesto que es un borrador del formulario.`,
                accion: 'guardarBorrador',
                data: valores
            })
        }
    }
    const botonEnviarSolicitudBorradorFC_06 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudBorradorFC_06'
        })
    }
    const botonReiniciarFormato = () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de reiniciar el formato, esta acción eliminará toda la información
            y no se podrá revertir.`,
            accion: 'reiniciarFormato'
        })
    }
    const botonRegistrarFC_06 = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy).toISOString()

        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio
        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            domiciliosolicitante: domicilio, nombreresponsable: valores.nombreresponsable, telefono: valores.telefono + '',
            predio: valores.predio, vivero: valores.vivero, email: valores.email + '',
            idestatusdesolicitudes: 7, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }
        const objetoCompletoFC_06 = {
            solicitud,
            predio,
            vivero
        }
        const resultado = await dispatch(agregarFC_06Accion(objetoCompletoFC_06))

        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_06())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const enviarCorreccion = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy)?.toISOString()
        const solicitud = {
            idfc06_registromaguey: data.idfc06_registromaguey,
            fechasolicitud: fechaSolicitud, nombrerazonsocial: dataCliente.nombrerazonsocial,
            domiciliosolicitante: domicilio, nombreresponsable: valores.nombreresponsable, telefono: valores.telefono + '',
            predio: valores.predio, vivero: valores.vivero, email: valores.email + '',
            idestatusdesolicitudes: 6, idlogin: idlogin,
        }
        const objetoCompletoFC_06 = {
            solicitud,
            predio,
            vivero
        }
        await dispatch(actualizarFC_06Solicitud(objetoCompletoFC_06))
        const idSolicitud = data.idfc06_registromaguey
        const estatusNuevo = 6
        const idCliente = null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_06 = 2
        const tabla = tablaFC_06
        await dispatch(actualizarFC_06Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
        ))
        await dispatch(resetDataFC_06())
        handleResetAllPropertys()
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/solicitudes')

    }
    const handleResetAllPropertys = () => {
        setPredio([])
        setVivero([])
        handleCloseModal()
        dispatch(resetDataFC_06())
    }
    const guardarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        let fechaSolicitud = new Date(fechaHoy).toISOString()
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))

        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            domiciliosolicitante: domicilio, nombreresponsable: valores.nombreresponsable, telefono: valores.telefono + '',
            predio: valores.predio, vivero: valores.vivero, idestatusdesolicitudes: 1, email: valores.email + '',
            idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }
        const objetoCompletoFC_06 = {
            solicitud,
            predio,
            vivero
        }
        const resultado = await dispatch(agregarFC_06Accion(objetoCompletoFC_06))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_06())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }
    const actualizarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        const solicitud = {
            idfc06_registromaguey: data.idfc06_registromaguey, email: valores.email + '',
            fechasolicitud: fechaSolicitud, nombrerazonsocial: dataCliente.nombrerazonsocial,
            domiciliosolicitante: domicilio, nombreresponsable: valores.nombreresponsable, telefono: valores.telefono,
            predio: valores.predio, vivero: valores.vivero, idestatusdesolicitudes: 1, idlogin: idlogin,
        }
        const objetoCompletoFC_06 = {
            solicitud,
            predio,
            vivero
        }
        const resultado = await dispatch(actualizarFC_06SolicitudBorrador(objetoCompletoFC_06))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_06())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }
    const enviarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        let fechaSolicitud = new Date(fechaHoy).toISOString()

        let idAduana = Number(valores.idaduanasalida)
        if (idAduana === 0) idAduana = null

        const solicitud = {
            idfc06_registromaguey: data.idfc06_registromaguey, email: valores.email + '',
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            domiciliosolicitante: domicilio, nombreresponsable: valores.nombreresponsable, telefono: valores.telefono + '',
            predio: valores.predio, vivero: valores.vivero, idestatusdesolicitudes: 1,
            idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos,
        }
        const objetoCompletoFC_06 = {
            solicitud,
            predio,
            vivero,
        }
        const resultado = await dispatch(actualizarFC_06SolicitudBorrador(objetoCompletoFC_06))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            const idSolicitud = data.idfc06_registromaguey
            const estatusNuevo = 7
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_06 = 2
            const tabla = tablaFC_06
            await dispatch(actualizarFC_06Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_06())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [paginas, setPaginas] = useStateIfMounted([1, 2, 4])
    const paginaActiva = useSelector(store => store.FC_06Solicitud.paginaActiva)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos generales', 'Predios/Viveros', 'Documentación'])
    const paginaSiguiente = async (valores) => {
        const result = await validation(valores)
        if (JSON.stringify(result) !== '{}') {
            settexto('')
            setvalidacion(true)
        } else {
            dispatch(actualizarFC_06PaginaActiva(paginaActiva + 1))
        }
    }
    const paginaAnterior = async () => {
        dispatch(actualizarFC_06PaginaActiva(paginaActiva - 1))
    }
    const resetValores = (objectProducto) => {
        //setProductos(prev => [...prev, objectProducto])
        setvalidacion(objectProducto.validacion)
    }


    const [predio, setPredio] = React.useState([])
    const handdlePredio = (objectPredio) => {
        setPredio(prev => [...prev, objectPredio])
    }
    const handdleRemovePredioPrev = async (objectPredio) => {
        if (objectPredio.data.idfc06_anexopredio) {
            await dispatch(eliminarFC_06AnexoPredioBD(objectPredio.data.idfc06_anexopredio))
        }
        const filtro = predio.filter(anexo => anexo.id !== objectPredio.data.id)
        setPredio(filtro)

    }
    const handdleEditPredioPrev = (paramsObjectPredio) => {
        const { ...objectPredio } = paramsObjectPredio
        if (fc_06PrediosMap.length > 0) {
            const filtro = predio.findIndex(anexo => anexo.idfc06_anexopredio === objectPredio.id)
            let editar = { ...predio[Number(filtro)] }
            const filtroEliminar = predio.filter(anexo => anexo.idfc06_anexopredio !== objectPredio.id)

            editar.nombreparaje = objectPredio.nombreparaje
            editar.estado = objectPredio.estado
            editar.distrito = objectPredio.distrito
            editar.municipio = objectPredio.municipio
            editar.localidad = objectPredio.localidad
            editar.cultivado = objectPredio.cultivado
            editar.semicultivado = objectPredio.semicultivado
            editar.silvestre = objectPredio.silvestre
            editar.domicilio = objectPredio.domicilio
            filtroEliminar.push(editar)
            setPredio(filtroEliminar)
        } else {
            const filtro = predio.findIndex(anexo => anexo.id === objectPredio.id)
            let editar = predio
            const newPredios = []
            for (const i in predio) {
                const { ...restProducto } = predio[i]
                newPredios.push(restProducto)
            }
            newPredios[Number(filtro)].nombreparaje = objectPredio.nombreparaje
            newPredios[Number(filtro)].estado = objectPredio.estado
            newPredios[Number(filtro)].distrito = objectPredio.distrito
            newPredios[Number(filtro)].municipio = objectPredio.municipio
            newPredios[Number(filtro)].localidad = objectPredio.localidad
            newPredios[Number(filtro)].cultivado = objectPredio.cultivado
            newPredios[Number(filtro)].semicultivado = objectPredio.semicultivado
            newPredios[Number(filtro)].silvestre = objectPredio.silvestre
            newPredios[Number(filtro)].domicilio = objectPredio.domicilio
            setPredio(newPredios)
        }
    }

    const [vivero, setVivero] = React.useState([])
    const handdleVivero = (objectVivero) => {
        setVivero(prev => [...prev, objectVivero])
    }
    const handdleRemoveViveroPrev = async (objectVivero) => {
        if (objectVivero.data.idfc06_anexovivero) {
            await dispatch(eliminarFC_06AnexoViveroBD(objectVivero.data.idfc06_anexovivero))
        }
        const filtro = vivero.filter(anexo => anexo.id !== objectVivero.data.id)
        setVivero(filtro)

    }
    const handdleEditViveroPrev = (paramsObjectVivero) => {
        const { ...objectVivero } = paramsObjectVivero
        if (fc_06PrediosMap.length > 0) {
            const filtro = vivero.findIndex(anexo => anexo.idfc06_anexovivero === objectVivero.id)
            let editar = { ...vivero[Number(filtro)] }
            const filtroEliminar = vivero.filter(anexo => anexo.idfc06_anexovivero !== objectVivero.id)

            editar.nombreparaje = objectVivero.nombreparaje
            editar.estado = objectVivero.estado
            editar.distrito = objectVivero.distrito
            editar.municipio = objectVivero.municipio
            editar.localidad = objectVivero.localidad
            editar.cultivado = objectVivero.cultivado
            editar.semicultivado = objectVivero.semicultivado
            editar.silvestre = objectVivero.silvestre
            editar.domicilio = objectVivero.domicilio
            filtroEliminar.push(editar)
            setVivero(filtroEliminar)
        } else {
            const filtro = vivero.findIndex(anexo => anexo.id === objectVivero.id)
            let editar = vivero
            const newVivero = []
            for (const i in vivero) {
                const { ...restProducto } = vivero[i]
                newVivero.push(restProducto)
            }
            newVivero[Number(filtro)].nombreparaje = objectVivero.nombreparaje
            newVivero[Number(filtro)].estado = objectVivero.estado
            newVivero[Number(filtro)].distrito = objectVivero.distrito
            newVivero[Number(filtro)].municipio = objectVivero.municipio
            newVivero[Number(filtro)].localidad = objectVivero.localidad
            newVivero[Number(filtro)].cultivado = objectVivero.cultivado
            newVivero[Number(filtro)].semicultivado = objectVivero.semicultivado
            newVivero[Number(filtro)].silvestre = objectVivero.silvestre
            newVivero[Number(filtro)].domicilio = objectVivero.domicilio
            setVivero(newVivero)
        }
    }
    const botonDomicilio = () => {
        let numInt = ''
        let numExt = ''
        let colonia = ''
        if (dataCliente.numerointerior === '' || dataCliente.numerointerior === null) numInt = 's/n'
        else numInt = dataCliente.numerointerior
        if (dataCliente.numeroexterior === '' || dataCliente.numeroexterior === null) numExt = 's/n'
        else numExt = dataCliente.numeroexterior
        if (dataCliente.colonia === '' || dataCliente.colonia === null) colonia = 's/n'
        else colonia = dataCliente.colonia

        return dataCliente.calle + ',' + numInt + ',' + numExt + ',' + colonia + ',' + dataCliente.localidad + ',' +
            dataCliente.municipioalcaldia + ',' + dataCliente.estado + ',' + dataCliente.codigopostal
    }
    const validation = values => {
        let errores = {};
        const textoCheck = 'Debe de seleccionar al menos una opción'
        const texto = 'Campo Obligatorio'
        if (paginaActiva === 1) {
            /*if (!values.domicilio) { errores.domicilio = texto }
            else {
                if (values.domicilio.length < 10) { errores.domicilio = "Ingresar el domicilio completo separado por una coma, (calle,número interior,número exterior,colonia,localidad,código postal,municipio,estado)" }
            }*/
            if (!values.nombreresponsable) { errores.nombreresponsable = texto }
            if (!values.telefono) { errores.telefono = texto } else {
                if ((values.telefono + '').length != 10) { errores.telefono = "Ingresar el teléfono a 10 digitos" }

            }
            if (!values.email) { errores.email = texto }
            if (!values.predio && !values.vivero) { errores.predio = textoCheck }

        }
        if (paginaActiva === 2) {
            if (values.predio) {
                if (predio.length <= 0) { errores.datospredio = 'Debe de agregar por lo menos un predio' }
            }
            if (values.vivero) {
                if (vivero.length <= 0) { errores.datosvivero = 'Debe de agregar por lo menos un vivero' }
            }

        }
        return errores;
    }
    return (
        <Fragment>
            <Formik
                initialValues={
                    fc_06
                }
                validate={validation}
                onSubmit={(valores) => {
                    if (botonEnviarRegistro) {
                        botonRegistrarFC_06(valores)
                    }
                    if (botonEnviarCorrecciones) {
                        enviarCorreccion(valores)
                    }
                    if (botonEnviarBorrador) {
                        enviarBorrador(valores)
                    }
                }}
            >
                {({ values, handleChange, handleSubmit, handleBlur, errors, touched, resetForm, submitForm, setValues }) => (
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className='container2'>
                            <div className='row mt-3'>
                                <div className='row'>
                                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-12 text-center marginsitoTop">
                                        <InfoBar nombreSolicitud={'Solicitud de registro de maguey'} />

                                    </div>
                                    {
                                        !modoCorreccion &&
                                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center marginsitoTop">
                                            <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                aria-label="Guardar cambios" aria-haspopup="true" onClick={() =>
                                                    botonGuardarComoBorrador(values)}
                                            >
                                                <SaveIcon />
                                                {
                                                    modoEdicionBorrador ? (
                                                        <div className="badge text-dark textoModal text-center">
                                                            Guardar cambios en borrador
                                                        </div>) : (
                                                        <div className="badge text-dark textoModal text-center">
                                                            Guardar como borrador
                                                        </div>
                                                    )
                                                }
                                            </IconButton>
                                        </div>
                                    }
                                    <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 text-center">
                                        <h1></h1>
                                    </div>
                                    {
                                        !modoCorreccion &&
                                        <div className="col-xs-12 col-sm-12 col-md-2 col-lg-1 col-xl-1 text-center marginsitoTop">
                                            <Fragment>
                                                <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                    aria-label="Reiniciar formato" aria-haspopup="true" color="error" onClick={() => { botonReiniciarFormato(), setFunctionResetForm({ function: resetForm }) }}
                                                >
                                                    <FormatClearIcon />
                                                    <div className="badge text-dark textoNormalbadge text-dark textoModal text-center">Reiniciar Formato </div>
                                                </IconButton>
                                            </Fragment>
                                        </div>
                                    }
                                </div>
                            </div>

                            <br />
                            {
                                paginaActiva === 1 ?
                                    <Fragment>
                                        <div className='row justify-content-start'>
                                            <div className='row'>
                                                <h6 className={`text-center ${estilos.labelNaranja}`}>Información del solicitante</h6>
                                            </div>
                                            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                <div className="form-floating mb-3">
                                                    <input type="text" className={`form-control ${fc_06Map.nombreresponsablecheck !== undefined ?
                                                        'inputValidado' : ''}`}
                                                        id="" placeholder='Domicilio del solicitante'
                                                        name="domicilio"
                                                        value={domicilio}
                                                        //onChange={handleChange}
                                                        //onBlur={handleBlur}
                                                        disabled
                                                    />
                                                    <label htmlFor='floatingInput'>Domicilio completo</label>
                                                    {/*touched.domiciliosolicitante && errors.domiciliosolicitante && <div className="text-danger">{errors.domiciliosolicitante}</div>*/}
                                                </div>
                                            </div>
                                            <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                                <div className="form-floating mb-3">
                                                    <input type="text" className={`form-control ${fc_06Map.nombreresponsablecheck !== undefined ? (
                                                        fc_06Map?.nombreresponsablecheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                        id="" placeholder='responsable'
                                                        name="nombreresponsable"
                                                        value={values.nombreresponsable}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label htmlFor='floatingInput'>Nombre de responsable de campo</label>
                                                    <span className='text-danger'>{fc_06Map?.nombreresponsablecheck ? fc_06Map?.nombreresponsable : ''}</span>
                                                    {touched.nombreresponsable && errors.nombreresponsable && <div className="text-danger">{errors.nombreresponsable}</div>}
                                                </div>
                                            </div>
                                            <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                                <div className="form-floating mb-3">
                                                    <input type="number" className={`form-control ${fc_06Map.telefonocheck !== undefined ? (
                                                        fc_06Map?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                        id="" placeholder='telefono'
                                                        name="telefono"
                                                        value={values.telefono}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label htmlFor='floatingInput'>Teléfono</label>
                                                    <span className='text-danger'>{fc_06Map?.telefonocheck ? fc_06Map?.telefono : ''}</span>
                                                    {touched.telefono && errors.telefono && <div className="text-danger">{errors.telefono}</div>}
                                                </div>
                                            </div>
                                            <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                                <div className="form-floating mb-3">
                                                    <input type="email" className={`form-control ${fc_06Map.emailcheck !== undefined ? (
                                                        fc_06Map?.emailcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                        id="" placeholder='Correo Electrónico'
                                                        name="email"
                                                        value={values.email}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label htmlFor='floatingInput'>Correo Electrónico</label>
                                                    <span className='text-danger'>{fc_06Map?.emailcheck ? fc_06Map?.email : ''}</span>
                                                    {touched.email && errors.email && <div className="text-danger">{errors.email}</div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <h6 className={`text-center ${estilos.labelNaranja}`}>Tipo de registro</h6>
                                        </div>
                                        <div className='row align-items-center'>
                                            <div className={`row  ${estilos.divSoloBorderNaranja}`}>
                                                {dataCliente.productormaguey &&
                                                    <div className={dataCliente.viverista && dataCliente.productormaguey ? 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6' : 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'}>
                                                        <input className={`form-check-input me-1 ${fc_06Map.prediocheck !== undefined ? (
                                                            fc_06Map?.prediocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                            checked={values.predio} id='predio' name="predio"
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.predio = e.target.checked
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                            Predio
                                                        </label><br />
                                                        <span className='text-danger'>{fc_06Map?.prediocheck ? fc_06Map?.predio : ''}</span>
                                                    </div>
                                                }
                                                {dataCliente.viverista &&
                                                    <div className={dataCliente.viverista && dataCliente.productormaguey ? 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6' : 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'}>
                                                        <input className={`form-check-input me-1 ${fc_06Map.viverocheck !== undefined ? (
                                                            fc_06Map?.viverocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                            checked={values.vivero} id='vivero' name="vivero"
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.vivero = e.target.checked
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur}
                                                        />

                                                        <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                            Vivero
                                                        </label><br />
                                                        <span className='text-danger'>{fc_06Map?.viverocheck ? fc_06Map?.vivero : ''}</span>
                                                    </div>
                                                }

                                                {touched.predio && errors.predio && <div className="text-danger">{errors.predio}</div>}
                                            </div>
                                        </div>
                                    </Fragment>
                                    :
                                    paginaActiva === 2 ?
                                        <Fragment>
                                            <div className='row align-items-center mt-3'>
                                                {values.predio &&
                                                    <Fragment>
                                                        <div className='row'>
                                                            <h6 className={`text-center ${estilos.labelNaranja}`}>DATOS DEL PREDIO</h6>
                                                        </div>
                                                        <TablaPredio api={{ handdlePredio, handdleRemovePredioPrev, handdleEditPredioPrev, predio }} prediosMap={fc_06PrediosMap} ></TablaPredio>
                                                        {touched.predio && errors.datospredio && <div className="text-danger text-center">{errors.datospredio}</div>}
                                                    </Fragment>}
                                                {values.vivero &&
                                                    <Fragment>
                                                        <div className='row'>
                                                            <h6 className={`text-center ${estilos.labelNaranja}`}>DATOS DEL VIVERO</h6>
                                                        </div>
                                                        <TablaVivero api={{ handdleVivero, handdleRemoveViveroPrev, handdleEditViveroPrev, vivero }} prediosMap={fc_06ViverosMap} ></TablaVivero>
                                                        {touched.vivero && errors.datosvivero && <div className="text-danger text-center">{errors.datosvivero}</div>}
                                                    </Fragment>}
                                            </div>
                                        </Fragment> :
                                        <Fragment>
                                            {
                                                modoCorreccion &&
                                                <div className={`${estilos.componenteDocFC_06} col-md-12`}>

                                                    <DocumentacionFC_06Component> </DocumentacionFC_06Component>
                                                </div>
                                            }
                                            {
                                                !modoCorreccion ?
                                                    <div>
                                                        <div className="row mt-4">
                                                            {
                                                                modoEdicionBorrador ? (
                                                                    <div className="d-grid gap-2 col-2 mx-auto">
                                                                        <button type="submit"
                                                                            onClick={() => { botonEnviarSolicitudBorradorFC_06(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                            className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                        >Enviar borrador</button>
                                                                    </div>
                                                                ) : (
                                                                    <div className="d-grid gap-2 col-2 mx-auto">
                                                                        <button type="submit"
                                                                            onClick={() => { botonEnviarSolicitudFC_06(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                            className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                        >Enviar</button>
                                                                    </div>
                                                                )
                                                            }

                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="row mt-4">
                                                        <div className="d-grid gap-2 col-2 mx-auto">
                                                            <button type="submit"
                                                                onClick={() => { botonEnviarCorreccionesFC_06(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                className={`btn ${estilos.botonNaranjaRedondo}`}>Enviar correcciones</button>
                                                        </div>
                                                    </div>
                                            }
                                        </Fragment>}
                            <br />
                        </div>
                        {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
                        <BotonAtrasSiguienteComponent botonSiguiente={paginaSiguiente} botonAnterior={paginaAnterior} paginaActiva={paginaActiva} totalDePaginas={paginas.length} valores={values} />
                        {modalComponent()}
                    </form>
                )}
            </Formik>
        </Fragment>
    )
}
export default withRouter(FormularioFC06BeneficiarioComponent)
